import { render, staticRenderFns } from "./app.vue?vue&type=template&id=d6442874"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "formater-commons-components-vjs/src/assets/css/formater-icon.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./app.vue?vue&type=style&index=1&id=d6442874&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./app.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports